import * as React from 'react';
import Button, { ButtonProps } from './Button';
import Paragraph from 'components/text/Paragraph';
import clsx from 'clsx';
import { Check, Loader2 } from 'lucide-react';

export type LoadingButtonProps = ButtonProps & {
  isLoading: boolean;
  isSuccess: boolean;
  label: string;
  loadingLabel: string;
  successLabel: string;
};

const LoadingButton: React.FC<LoadingButtonProps> = ({
  isLoading,
  isSuccess,
  label,
  successLabel,
  loadingLabel,
  ...props
}) => {
  const renderIcon = () => {
    if (isSuccess) {
      return <Check className="!text-success-main" size={18} />;
    }

    if (isLoading) {
      return <Loader2 className="!text-neutral-400 animate-spin" size={18} />;
    }

    return null;
  };

  const renderLabel = () => {
    if (isSuccess) {
      return <Paragraph className="!text-success-main">{successLabel}</Paragraph>;
    }

    if (isLoading) {
      return <Paragraph className="!text-neutral-400">{loadingLabel}</Paragraph>;
    }

    return <Paragraph className="!text-white">{label}</Paragraph>;
  };

  return (
    <Button
      {...props}
      className={clsx(
        'LoadingButton flex gap-2 justify-center align-center w-full',
        props.className,
        {
          ['!bg-neutral-300']: isLoading,
          ['!bg-success-light']: isSuccess
        }
      )}
    >
      {renderIcon()}
      {renderLabel()}
    </Button>
  );
};

export default LoadingButton;
